import { useCallback, useLayoutEffect, useRef, useState } from "react";
const useWidth = (scrollableWidth, recalculateWidth) => {
    const ref = useRef(null);
    const [width, setWidth] = useState(null);
    const provideWidth = useCallback(() => {
        if (ref.current) {
            setWidth(ref.current.clientWidth);
        }
    }, []);
    useLayoutEffect(() => {
        provideWidth();
        window.addEventListener("resize", provideWidth);
        if (scrollableWidth !== undefined && ref.current && width !== null) {
            ref.current.scrollTo(Math.max((scrollableWidth - width) / 2, 0), 0);
        }
        return () => window.removeEventListener("resize", provideWidth);
    }, [provideWidth, scrollableWidth, width, recalculateWidth]);
    return { widgetRef: ref, widgetWidth: width };
};
export { useWidth };
